import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { BUSINESS_DOCUMENT_ENDPOINTS } from '../../../core/api/api-endpoints';
import { RestApiService } from '../../../core/api/rest-api.service';

export interface BusinessDocumentEventRecord {
  id: string;
  organisation_id: string;
  document_owner: string;
  document_type: string;
  document_id: string;
  document_reference: string | null;
  event_type: string;
  event_label: string;
  from_status: string | null;
  to_status: string | null;
  actor_user_id: string | null;
  actor_employment_id: string | null;
  actor_name_snapshot: string | null;
  actor_email_snapshot: string | null;
  related_document_owner: string | null;
  related_document_type: string | null;
  related_document_id: string | null;
  related_document_reference: string | null;
  notes: string | null;
  metadata: Record<string, unknown>;
  occurred_at: string;
  created_at: string;
  event_sequence?: number;
  before_snapshot?: Record<string, unknown> | null;
  after_snapshot?: Record<string, unknown> | null;
  snapshot_state?: 'captured' | 'created' | 'unavailable';
  snapshot_scope?: 'registry' | 'owner_aggregate' | null;
}

@Injectable({
  providedIn: 'root',
})
export class BusinessDocumentEventTimeline {
  constructor(private readonly restApi: RestApiService) {}

  list(
    documentOwner: BusinessDocumentEventRecord['document_owner'],
    documentType: string,
    documentId: string,
    limit = 200
  ): Observable<BusinessDocumentEventRecord[]> {
    return this.restApi.get<BusinessDocumentEventRecord[] | { records?: BusinessDocumentEventRecord[] }>(
      BUSINESS_DOCUMENT_ENDPOINTS.events,
      {
        params: {
          document_owner: documentOwner,
          document_type: documentType,
          document_id: documentId,
          limit,
        },
      },
    ).pipe(map((response) => Array.isArray(response) ? response : response.records ?? []));
  }
}
